<template>
  <Modal title="Создание штрихкода" @backdrop-click="close">
    <template slot="body">
      <notifications group="barcode-modal" />
      <canvas ref="modalBarcode" />
      <input class="form-control" v-model="barcode" />
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            type="button"
            class="btn btn-success"
            :disabled="!isValid"
            @click="close"
          >
            <i class="fa fa-fw fa-save" />
            Сохранить
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import JsBarcode from 'jsbarcode';
import Modal from '@/_shared/components/ui/Modal';
import { useNotification } from '@/_shared/mixins';
import { configs } from '@/_shared/constants';
export default {
  emits: ['close'],
  mixins: [useNotification],
  components: {
    Modal,
  },
  props: {
    initValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      notificationGroup: 'barcode-modal',
      barcode: this.initValue || '1234567890128',
      isValid: true,
    };
  },
  watch: {
    barcode() {
      this.renderBarcode();
    },
  },
  mounted() {
    this.renderBarcode();
  },
  methods: {
    close() {
      if (this.isValid) {
        this.$emit('close', this.barcode);
      }
    },
    renderBarcode() {
      const handleError = (currentStatus) => {
        const previousValueIsValid = this.isValid;
        if (previousValueIsValid && !currentStatus) {
          const text = 'Значение штрихкода неверное';
          this.showErrorNotification(text);
        }
        this.isValid = currentStatus;
      };
      const config = configs.jsBarcode;
      config.general.valid = handleError;
      JsBarcode(this.$refs.modalBarcode)
        .options(config.general)
        .EAN13(this.barcode, config.barcode)
        .blank(config.blankSize)
        .render();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/_shared/components/modals/BarcodeModal.vue